import { render, staticRenderFns } from "./usersModal.vue?vue&type=template&id=97c8ada0"
import script from "./usersModal.vue?vue&type=script&lang=js"
export * from "./usersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports